import type {
  SectionValue,
  RedFlagsSection as RedFlagsData,
} from "../../../../shared/analysis-types";
import { SectionHeader } from "./section-header";
import { RedFlagCard } from "./red-flag-card";
import { RedFlagsEmptyCard } from "./red-flags-empty-card";
import { SectionErrorFallback } from "./section-error-fallback";
import { CopyFormattedButton } from "@/components/copy-formatted-button";
import { formatRedFlagsCopy } from "@/lib/analysis-copy-format";

interface RedFlagsSectionProps {
  data: SectionValue<RedFlagsData>;
  className?: string;
}

export function RedFlagsSection({ data, className }: RedFlagsSectionProps) {
  if ("error" in data) {
    return (
      <div className={className}>
        <SectionHeader title="Red Flags" />
        <div className="mt-4">
          <SectionErrorFallback sectionName="red_flags" />
        </div>
      </div>
    );
  }

  const hasFlags = data.flags.length > 0;

  return (
    <div className={className}>
      <SectionHeader
        title="Red Flags"
        count={hasFlags ? data.flags.length : undefined}
        action={
          <CopyFormattedButton format={formatRedFlagsCopy(data)}>
            Copy section
          </CopyFormattedButton>
        }
      />
      <div className="mt-4 flex flex-col gap-6">
        {hasFlags ? (
          data.flags.map((flag, i) => <RedFlagCard key={i} flag={flag} />)
        ) : (
          <RedFlagsEmptyCard />
        )}
      </div>
    </div>
  );
}
